exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.el-tooltip__popper {\n  width: 248px;\n}\n", "", {"version":3,"sources":["/Users/admin/Documents/env/jenkins_workspace/prod2-uc-static-lzauth/src/views/page/main/registry/registry.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd","file":"registry.vue","sourcesContent":["\n.el-tooltip__popper {\n  width: 248px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8504321e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/page/main/registry/registry.vue
// module id = YVU5
// module chunks = 2 3